export const PillColorsExtended = {
  SELECTED: 'selected',
  NEUTRAL: 'neutral',
} as const;
